import { withDependencies } from '@wix/thunderbolt-ioc'
import { IViewerManagerImplementor } from 'thunderbolt-viewer-manager-types'
import { DSViewModeAPISymbol, LOADING_PHASES, LoggerSymbol, ILogger, IViewMode } from '@wix/thunderbolt-symbols'

const viewerManagerViewModeApiFactory = (
	viewMode: IViewMode,
	logger: ILogger
): IViewerManagerImplementor<'viewMode'> => {
	return {
		viewMode: {
			isMobileView: viewMode.isMobileView,
			isDuringViewModeSwitch: viewMode.isDuringViewModeSwitch,
			// @ts-ignore
			waitForViewModeChange: () => viewMode.getNextViewModeSwitchIntent(),
			registerToSwitchViewModeDone: viewMode.registerToSwitchViewModeDone,
			registerToNextSwitchViewModeDone: (handler) => {
				logger.phaseStarted(LOADING_PHASES.DS_WAIT_FOR_VIEW_MODE)
				viewMode.registerToNextSwitchViewModeDone(() => {
					logger.phaseEnded(LOADING_PHASES.DS_WAIT_FOR_VIEW_MODE)
					handler()
				})
			},
		},
	}
}
export const ViewerManagerViewModeApi = withDependencies(
	[DSViewModeAPISymbol, LoggerSymbol],
	viewerManagerViewModeApiFactory
)
